<div>
  <div class="test" style="text-align: center">
    <div class="col-sm-12">
      <h3>{{title}}</h3>
      <h3>{{subTitle}}</h3>
    </div>
    <form [formGroup]="form">
      <div class="col-sm-12">
        <mat-icon class="col-sm-2" style="bottom: auto;" [color]="icon_color">{{icone}}</mat-icon>
        <div>
          <app-custom-select-multiple-option 
           [InputvaluesList]="societyInputList" 
          [InputSelectedValues]="listUpdated"  (selected)="onSocietyChange($event)"  [title]="'Société'"
          [required]="true">
        </app-custom-select-multiple-option>
        </div>
      </div>
      <div class="col-sm-12">
        <mat-form-field class="full-width">
          <mat-label>Date début</mat-label>
          <input required matInput [matDatepicker]="startpickerD" name="nth-date-start" formControlName="startDate">
          <mat-datepicker-toggle matSuffix [for]="startpickerD"></mat-datepicker-toggle>
          <mat-datepicker #startpickerD></mat-datepicker>
          <mat-error *ngIf="form.get('startDate').hasError('required')">
            Veuillez saisir une date de debut
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-sm-12">
        <mat-form-field class="full-width">
          <mat-label>Date fin</mat-label>
          <input required matInput [matDatepicker]="endpickerD" name="nth-date-end" formControlName="endDate">
          <mat-datepicker-toggle matSuffix [for]="endpickerD"></mat-datepicker-toggle>
          <mat-datepicker #endpickerD></mat-datepicker>
          <mat-error *ngIf="form.get('endDate').hasError('required')">
            Veuillez saisir une date de fin
          </mat-error>
          <mat-error *ngIf="form.get('endDate').hasError('inferieur')">
            Veuillez saisir une date de fin supérieur a la date de debut
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-sm-12">
        <mat-form-field class="full-width">
          <mat-label>Date d'exercice</mat-label>
          <input  matInput  type="month" name="nth-date-peride" placeholder="MOIS ET ANNEE (MMYYYY)" formControlName="periode">
          <mat-error *ngIf="form.get('periode').hasError('pattern')">
            Veuillez saisir un format de date valide: Mois ANNEE, exemple: Juin 2021
          </mat-error>
          <mat-error *ngIf="form.get('periode').hasError('required')">
            Veuillez saisir une date d'exercice
          </mat-error>
        </mat-form-field>

        
      </div>
    </form>
   
    
    <div class="col-sm-12">
      <mat-divider></mat-divider>
    </div>
    <div class="row">
      <div class="col-sm-6" style="margin-top: 40px;">
        <button mat-raised-button color="default" (click)="onModalCancel()">Annuler</button>
      </div>
      <div class="col-sm-6" style="margin-top: 40px;">
        <button mat-raised-button [color]="color" [disabled]="!form.valid" (click)="onModalConfirm()">Confirmer</button>
      </div>
    </div>
  </div>
</div>